import { useEffect, useState } from "react";
import "./Upload.css";
import {
  getRajFiles,
  getRajFileTypes,
  uploadRajFile,
} from "../../Rajasthan/Utility/RestApi";
import Loading from "../../../components/Loading";
import { RajasthanUploadFile } from "../../../models/rajasthan";
import PaginationTable from "../../../components/Table";
import { Upload } from "lucide-react";
import { DynamicDatePicker } from "../../../components/DatePicker";
import { getLast7DaysDateRange } from "../const";
import { invalidateCacheByPattern } from "../../../Rest_api/Network_utility";

export default function RajUpload() {
  const [selectedFileType, setSelectedFileType] = useState("");
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [files, setFiles] = useState<RajasthanUploadFile[]>([]);
  const [fileTypeList, setFileTypeList] = useState<string[]>([]);
  const [filteredFiles, setFilteredFiles] = useState<RajasthanUploadFile[]>([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const columnNames = ["Uploaded At", "Type", "Date", "File Link"];
  const columnKeys = ["uploaded_at", "type", "user_date", "file_url"];
  const [selectedDateRange, setSelectedDateRange] = useState(
    getLast7DaysDateRange()
  );

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      await getAllFileTypes();
      await getFiles();
      setLoading(false);
    };
    fetchAll();
  }, []);

  useEffect(() => {
    const filteredFiles = files.filter((file) =>
      file.type.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredFiles(filteredFiles);
  }, [files, searchText]);

  useEffect(() => {
    if (selectedDateRange) {
      const filteredFiles = files.filter((file) => {
        if (!file.user_date) return false;
        const fileDate = new Date(file.user_date);
        return (
          fileDate >= selectedDateRange.startDate &&
          fileDate <= selectedDateRange.endDate
        );
      });
      setFilteredFiles(filteredFiles);
    }
  }, [files, selectedDateRange]);

  const getFiles = async () => {
    const res = await getRajFiles();
    setFiles([]);
  };

  const getAllFileTypes = async () => {
    const res = await getRajFileTypes();
    setFileTypeList(res);
  };

  const handleFileTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedFileType(event.target.value);
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setUploadedFile(file);
    }
  };

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedDate(event.target.value);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);

    if (!selectedDate) {
      alert("Please select a date before submitting!");
      setLoading(false);
      return;
    }
    if (!selectedFileType) {
      alert("Please select a file type before uploading!");
      setLoading(false);
      return;
    }
    if (!uploadedFile) {
      alert("Please upload a file before submitting!");
      setLoading(false);
      return;
    }

    // Create FormData object
    const formData = new FormData();
    formData.append("file", uploadedFile); // Append the uploaded file
    formData.append("date", selectedDate); // Append the selected date
    formData.append("type_name", selectedFileType); // Append the selected file type

    try {
      // await uploadRajFile(formData);

      invalidateCacheByPattern("/getRajUploadedFile");
      getFiles();
      alert(
        `File "${uploadedFile.name}" submitted successfully on ${selectedDate} as "${selectedFileType}"!`
      );

      // Reset form state
      setSelectedFileType("");
      setUploadedFile(null);
      setSelectedDate("");
    } catch (error) {
      // Handle error response
      alert(`File submission failed: ${error}`);
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="m-4" style={{ height: "unset!important" }}>
        {loading && <Loading />}

        <form
          onSubmit={handleSubmit}
          id="raj-upload"
          className="w-full mb-4 flex gap-10 items-center bg-white p-3 rounded-lg"
        >
          <div className="flex gap-3 items-center">
            <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center text-white text-xs font-semibold shadow-sm">
              1
            </div>
            <input
              type="date"
              required={true}
              value={selectedDate}
              onChange={handleDateChange}
              placeholder="MM/DD/YYYY"
              className="border border-[#C5C5CBD9] rounded-lg p-2 text-[#8C8A96]"
            />
          </div>

          <div className="flex gap-3 items-center">
            <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center text-white text-xs font-semibold shadow-sm">
              2
            </div>

            <select
              required={true}
              className="border border-[#C5C5CBD9] rounded-lg p-2 max-w-[200px] text-[#8C8A96] "
              value={selectedFileType}
              onChange={handleFileTypeChange}
            >
              <option value="" disabled>
                Select File Type
              </option>
              {fileTypeList.map((fileType, index) => (
                <option key={index} value={fileType}>
                  {fileType}
                </option>
              ))}
            </select>
          </div>
          <div className="flex gap-3 items-center">
            <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center text-white text-xs font-semibold shadow-sm">
              3
            </div>

            <div className="">
              <label className="downloadButton cursor-pointer font-medium flex items-center gap-3 h-[38px]">
                Upload File <Upload size={20} />
                <input
                  required={true}
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleFileUpload}
                />
              </label>
              {uploadedFile && (
                <p className="uploaded-file-name">
                  Uploaded File: {uploadedFile.name}
                </p>
              )}
            </div>
          </div>

          <div className="flex gap-3 items-center flex-1">
            <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center text-white text-xs font-semibold shadow-sm">
              4
            </div>

            <div className="flex-1">
              <input
                type="text"
                placeholder="File discription"
                className="border border-[#C5C5CBD9] rounded-lg p-2  text-[#8C8A96] w-full"
              />
            </div>
          </div>

          <button
            type="submit"
            className="bg-primary text-white h-[38px] px-6 rounded-full text-sm"
          >
            Submit
          </button>
        </form>

        <div className="bg-white py-2 px-4 rounded-lg mb-4 flex items-center gap-3 justify-between">
          <h2 className="chartHeading w-60">Uploaded Files</h2>

          <div className="flex gap-3 items-center">
            <input
              placeholder="Search files by type"
              className="border h-[2.5rem] rounded-lg p-2"
              type="search"
              onChange={(e) => setSearchText(e.target.value)}
            />

            <span className="text-zinc-300">|</span>

            <DynamicDatePicker
              setDate={(date) => {
                setSelectedDateRange(date[0]);
              }}
              defaultDates={selectedDateRange}
            />
          </div>
        </div>
        <PaginationTable
          columnNames={columnNames}
          columnKeys={columnKeys}
          data={filteredFiles.reverse()}
          ITEMS_PER_PAGE={15}
          hyperlinkColumns={{ file_url: "file_url" }}
          hyperlinkText="View File"
        />
      </div>

      <div className="gna-footer-container">
        <div className="grid grid-cols-2 justify-between gap-5 ">
          <p className="gna-footer-text">
            Powered by <strong>GNA Energy</strong>
          </p>
          <strong className="gna-footer-text  text-end">Demo Version</strong>
        </div>
      </div>
    </>
  );
}
